import React, {FunctionComponent} from "react";
import ButtonLink, {ButtonLinkProps} from "../../snippet/button/ButtonLink";
import {TranslationLibFile} from "../../../utils/locale";
import {useTranslation} from "react-i18next";
import {Action} from "../../../utils/Action";

type ButtonLinkCancelProps = Omit<ButtonLinkProps, "children" | "icon" | "reverse" | "reverseUnderline">;

const ButtonLinkCancel: FunctionComponent<ButtonLinkCancelProps> = (props) => {
    const {t} = useTranslation(TranslationLibFile.COMMON);

    return (
        <ButtonLink {...props}>
            {t(Action.CANCEL.labelKey)}
        </ButtonLink>
    );
};

export default ButtonLinkCancel;
